import React, { Component } from 'react';
import { any } from 'prop-types';
import { get, filter, map, size, head, groupBy, includes } from 'lodash';
import gql from 'graphql-tag';
import QueryManager from './Query';
import { withReloadable } from '../../hoc';
import { orderProductsByStatus } from '../../utils/misc';

export const QUERY_GET_ORDER_BY_ID = gql`query getOrderById($filters: [FilterInput]) {
    pickingFeed(filters: $filters) {
        results {
            ... on PickingProcess {
                    courierDelivery
                    weightError
                    isTraditional
                    semaphore
                    isPersonalShopperCustomer
                    eanOrder,
                    updatedAt,
                    idUser,
                    amountInvoice,
                    status {
                        label
                        code
                    }
                    foundRate
                    fillRate
                    pickingStats {
                        fillRate
                        quantityPicked
                        quantityRequested
                    }
                    pickingTime {
                        stats {
                            init
                            end
                            correlative
                            field
                        }
                    }
                    baggingInfo {
                        detail {
                            correlative
                            id
                            type
                            randomId
                        }
                        images
                    }
                    posDetail {
                        date
                        hour
                        documentNumber
                        amount
                        url
                        origin
                        urlChangeTicket
                    }
                    removedItems {
                        brandName
                        ean
                        name
                        originalQuantity
                        price
                        unit
                        unitMultiplier
                        sellingPrice
                        productId
                        id
                        sku
                        status
                        name
                        ean
                        originalQuantity
                        pickingQuantity
                        unit
                    }
                        ordersBipicking
                    order {
                        id     
                        numOrder
                        shippingChange
                        origin
                        windowAnticipated
                        extIssueIsDelayed
                        extIssueDelayedByQueuing
                        storeName
                        sequence
                        salesChannelId
                        isWhatsapp
                        idStore
                        items {
                            id
                            ean
                            name
                            imageUrl
                            sku
                            brandName
                            listPrice
                            quantity
                            sellingPrice
                            basePrice
                            customerNotes
                            unitMultiplier
                            substitution {
                                label
                                code
                            }
                            priceTags {
                                value
                                rateAndBenefit {
                                    name
                                }
                            }
                            unit
                        }
                        status
                        createdAt
                        downloadedAt
                        storeKind
                        contactPreference
                        receiverData {
                            firstName
                            lastName
                            document
                        }
                        totals {
                            id
                            name
                            value
                        }
                        itemCount
                        skuCount
                        substitutionType {
                            label
                            code
                        }
                        selectedAddress {
                            addressLine
                            addressType
                            addressId
                            postalCode
                            city
                            state
                            country
                            street
                            number
                            neighborhood
                            complement
                            receiverName
                            receiverDocument
                            geoCoordinates
                            reference
                        }
                        paymentData {
                            commercePayment {
                                card {
                                    brand
                                }
                            }
                            transactions {
                                payments {
                                    installments
                                    authCode
                                    method
                                    lastDigits
                                    amount
                                }
                            }
                    }
                    logisticsInfo {
                        selectedSla
                        shippingEstimateDate
                        shippingEstimate
                        deliveryWindow {
                            price
                            startDateUtc
                            endDateUtc
                        }
                        deliveryIds {
                            courierId
                            courierName
                            dockId
                            quantity
                            warehouseId
                        }
                        shippingETA
                        shippingETAend
                        promiseShippingETA
                        promiseShippingETAend
                        isDynamicWindow
                    }
                    salesChannel {
                        id
                        name
                    }
                    customer {
                        email
                        lastName
                        firstName
                        document
                        phone
                        isVIP
                        isUltraVIP
                        isCencoPrime
                        userProfileId
                        address {
                            addressLine
                            city
                            state
                        }
                    }
                }
                pickedCount
                addedCount
                noStockCount
                replacedCount
                noStockAmount
                replacedAmount
                replacedWithExcessAmount
                pickedAmount
                pickedItemCount
                addedAmount
                unpickedCount
                unpickedAmount
                status {
                    code
                    label
                }
                pickingTime {
                    init
                    end
                }
                items {
                    id
                    brandName
                    pickingQuantity
                    sku
                    sellingPrice
                    manualPicking
                    unitMultiplier
                    unpackaged
                    name
                    unit
                    ean
                    price
                    status
                    pickingQuantity
                    originalQuantity
                    substitution {
                        unpackaged
                        unit
                        ean
                        price
                        status
                        pickingQuantity
                        name
                    }
                }
            }
        }
    }
}
`;

class OrderById extends Component {
    static propTypes = {
        children: any
    }

    render () {
        const { children, ...props } = this.props;

        return (
            <QueryManager query={QUERY_GET_ORDER_BY_ID} {...props}>
                {({ data, loading, fetchMore, refetch, networkStatus }) => {
                    const { order, pickingTime, ...assignInfo } = get(data, 'pickingFeed.results.0', {});
                    const response = { 
                        weightError: get(data, 'pickingFeed.results.0.weightError'),
                        semaphore: get(data, 'pickingFeed.results.0.semaphore'),
                        assignInfo, 
                        pickingTime, 
                        ...order 
                    };

                    const filterItemsByStatus = (asked = '', from = 'items') => {
                        const items = filter(get(assignInfo, from, []), ({ status }) => status === asked);
                        const result = map(items, ({ price, pickingQuantity, originalQuantity, ...item }) => {
                            const listPrice = `${price}`.substring(0, size(`${price}`) - 2);
                            return {
                                basePrice: listPrice,
                                listPrice,
                                quantity: includes(['UNPICK_BY_STORE'], asked) ? originalQuantity : pickingQuantity,
                                ...item
                            };
                        });
                        return result;
                    };

                    const itemsAddedByClient = filterItemsByStatus('ADDED_BY_CLIENT');
                    const unpickedFromStore = filterItemsByStatus('UNPICK_BY_STORE', 'removedItems');

                    const pickedItems = get(response, 'assignInfo.items', []);
                    // const removedItems = get(response, 'assignInfo.removedItems', []);
                    const orderItems = get(response, 'items', []);
                    const result = map(orderItems, ({ id, ...item }) => {
                        return { id, picking: head(get(groupBy(pickedItems, 'id'), id)), ...item };
                    });
                    //console.log(result, orderProductsByStatus([...result, ...itemsAddedByClient]))

                    return children({
                        data: response,
                        orderItems: orderProductsByStatus([...result, ...itemsAddedByClient]),
                        itemsAddedByClient,
                        unpickedFromStore,
                        refetch,
                        loading,
                        fetchMore: ({ pageSize }) => fetchMore({
                            query: QUERY_GET_ORDER_BY_ID,
                            variables: { size: pageSize },
                            updateQuery: () => (null)
                        }),
                        networkStatus
                    });
                }}
            </QueryManager>
        );
    }
}

export default withReloadable(OrderById, ['ts']);